/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioSpeakerIcon24Solid = forwardRef('MediaAudioSpeakerIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 11a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V6Zm3 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-6.62a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z" })));
});
